<template>
  <div>
    <b-row>
      <b-col sm="12">
        <p>
          <strong>O que é Notificação da Autuação?</strong>
        </p>
        <ul>
          <li class="mb-3">
            A notificação de autuação serve para que o infrator tenha o
            conhecimento de que foi lavrado o Auto de Infração de Trânsito - AIT
            e, a partir de então, poderá indicar o condutor que cometeu a
            infração no veículo (Identificação Condutor Infrator - FICI), a fim
            de que a pontuação não seja creditada na carteira do proprietário,
            e/ou apresentar Defesa Prévia (Defesa de Autuação).
          </li>
        </ul>
      </b-col>
    </b-row>
    <hr />
    <b-row>
      <b-col sm="4">
        <b-form-group
          label="Número Notificação"
          label-size="sm"
          label-class="text-secondary"
        >
          <span class="font-weight-bold">
            {{ temValor(notificacao.numero_notificacao) }}
          </span>
        </b-form-group>
      </b-col>
      <b-col sm="4" v-if="!auto_infracao_transito.isCancelado()">
        <b-form-group label-size="sm" label-class="text-secondary">
          <template slot="label"
            ><span>Prazo Identificação Condutor Infrator - FICI&nbsp;</span
            ><b-icon
              v-b-tooltip.hover
              title="FICI - Identificação do Condutor Infrator"
              class="text-dark"
              icon="question-circle-fill"
            ></b-icon
          ></template>
          <span class="font-weight-bold">
            {{ temValor(dataBrasil(auto_infracao_transito.prazo_fici)) }}
          </span>
        </b-form-group>
      </b-col>
      <b-col sm="4" v-if="!auto_infracao_transito.isCancelado()">
        <b-form-group
          label="Prazo Entrada de Defesa de Autuação"
          label-size="sm"
          label-class="text-secondary"
        >
          <span class="font-weight-bold">
            {{ temValor(dataBrasil(auto_infracao_transito.prazo_defesa)) }}
          </span>
        </b-form-group>
      </b-col>
    </b-row>

    <b-row>
      <b-col sm="4">
        <b-form-group
          label="Data Emissão"
          label-size="sm"
          label-class="text-secondary"
        >
          <span class="font-weight-bold">
            {{ temValor(dataBrasil(notificacao.data_emissao)) }}
          </span>
        </b-form-group>
      </b-col>
      <b-col sm="4">
        <b-form-group
          label-size="sm"
          label-class="text-secondary"
        >
          <template slot="label"
            ><span v-if="possuidor.ind_adesao_veiculo_sne">Data Postagem (Registro SNE)</span
          >
          <span v-else>Data Postagem (Correios)</span
          ></template>
          <span class="font-weight-bold">
            {{ temValor(dataBrasil(notificacao.data_postagem)) }}
          </span>
        </b-form-group>
      </b-col>
      <b-col v-if="!possuidor.ind_adesao_veiculo_sne" sm="4">
        <b-form-group label-size="sm" label-class="text-secondary">
          <template slot="label"
            ><span>Data Publicação DOM&nbsp;</span
            ><b-icon
              v-b-tooltip.hover
              title="DOM - Diário Oficial do Município de Belo Horizonte"
              class="text-dark"
              icon="question-circle-fill"
            ></b-icon
          ></template>
          <span class="font-weight-bold">
            {{ temValor(dataBrasil(notificacao.data_publicacao_dom)) }}
          </span>
        </b-form-group>
      </b-col>
    </b-row>
    <b-overlay :show="showmanowanderley" rounded="sm">
      <pessoa-ait
        :pessoa="possuidor"
        :tituloPossuidor="'Proprietário do Veículo no momento da emissão da Notificação de Autuação'"
      />
    </b-overlay>
  </div>
</template>

<script>
import AutoInfracaoTransito from "@/models/AutoInfracaoTransito";
import Notificacao from "@/models/Notificacao";
import { helperDatas } from "@/helpers";
import PessoaAutoInfracaoTransito from "@/models/PessoaAutoInfracaoTransito";
import PessoaAit from "@/views/consulta_multa/aba/_pessoa";

export default {
  name: "NotificacaoNIT",

  components: {
    PessoaAit,
  },

  props: {
    dadosAit: {
      type: Object,
      default: function () {
        return {};
      },
    },
    auto_infracao_transito: {
      type: Object,
      default: function () {
        return new AutoInfracaoTransito();
      },
    },
  },

  data() {
    return {
      notificacao: new Notificacao(),
      dom_publicacao: {},
      possuidor: new PessoaAutoInfracaoTransito(),
      carregado: false,
      showmanowanderley: false,
    };
  },

  watch: {},

  methods: {
    dataBrasil(vlaor) {
      return helperDatas.dataBrasil(vlaor);
    },

    temValor(valor) {
      return valor ? valor : "-";
    },

    loadInfos() {
      if (!this.carregado) {
        this.carregado = true;
        this.showmanowanderley = true;
        this.showmanowanderleyFici = true;
        this.inicializar();
        this.$api.Multa.buscarTitularInfracaoNit({
          hash: this.auto_infracao_transito.hash,
        })
          .then(async (response) => {
            this.showmanowanderley = false;
            if (response.data.success && response.data.data) {
              this.possuidor = new PessoaAutoInfracaoTransito(
                response.data.data
              );
            }
          })
          .catch(() => {
            this.showmanowanderley = false;
          });
      }
    },

    inicializar() {
      if (this.auto_infracao_transito.notificacao.length > 0) {
        var notificacao = this.auto_infracao_transito.notificacao.find(
          (el) =>
            el.lote_remessa_correio.id != null &&
            el.lote_remessa_correio.tipo_notificacao.isNIT()
        );
        if (notificacao == null)
          notificacao = this.auto_infracao_transito.notificacao.find(
            (el) =>
              el.notificacao_pendente.id != null &&
              el.notificacao_pendente.tipo_notificacao.isNIT()
          );
        else if (
          notificacao.lote_remessa_correio.id != null &&
          notificacao.lote_remessa_correio.dom_publicacao_lote != null &&
          notificacao.lote_remessa_correio.dom_publicacao_lote.length > 0
        )
          this.dom_publicacao =
            notificacao.lote_remessa_correio.dom_publicacao_lote[0].dom_publicacao;

        this.notificacao = new Notificacao(notificacao);
      }
    },
  },
  mounted() {},
};
</script>

<style scoped>
.input-group-sm > .form-control {
  font-weight: 700 !important;
}
</style>